module.exports = __webpack_public_path__ + "images/daimler_small2ee1f26e705103fbe56aed14239a855c.png";